import { BtnDefault } from "@/components/Button";
import { WarningTwoIcon } from "@chakra-ui/icons";
import {
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  useBreakpointValue
} from "@chakra-ui/react";

type AddressModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onOpen: () => void;
  callback: () => void; // * Set search by address as active
  cancelCallback: () => void; // * Set search by address as inactive and cancel update
};

// * main render function
function AddressModal(data: AddressModalProps) {
  // * breakpoint rule
  const WideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  const { isOpen, onClose } = data;
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
      isCentered
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent mx={["1rem", "0"]}>
        <ModalBody>
          <Flex direction="column" my="1rem">
            <Text
              as="div"
              fontWeight="bold"
              fontSize="h1"
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap=".4rem"
            >
              <WarningTwoIcon />
              Atenção!
            </Text>
            <Text textAlign="justify" mt="1rem">
              Parece que o CEP que você inseriu não é mais válido, para
              continuar, será necessário realizar uma busca pelo endereço.
            </Text>
            <Text textAlign="center" mt="1rem" fontWeight="bold">
              Deseja continuar?
            </Text>
            <Flex gap="1rem" mt="2rem">
              <BtnDefault
                bg="gray.300"
                _hover={{ bg: "gray.500" }}
                fontWeight="bold"
                children={"Agora não!"}
                onClick={() => {
                  data.onClose();
                  data.cancelCallback();
                }}
              />

              <BtnDefault
                bg="green.900"
                _hover={{ bg: "green" }}
                children={"Sim, buscar!"}
                onClick={() => {
                  data.onClose();
                  data.callback();
                }}
              />
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export { AddressModal };
